var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "col-lg-4 col-sm-6" }, [
    _c("div", { staticClass: "lc-project-box box-shadow" }, [
      _c(
        "div",
        { class: ["lc-project"] },
        [
          _c("ProjectCardCarousel", {
            attrs: {
              images: _vm.getProjImages(),
              lifeDetailsUrl: _vm.project.details_url,
            },
            on: { navigatedTo: _vm.navigated },
          }),
          _c("div", { class: ["lc-data-panel"] }, [
            _c(
              "div",
              {
                staticClass: "lc-project-data",
                on: {
                  click: function ($event) {
                    return _vm.navigate(_vm.project.details_url)
                  },
                },
              },
              [
                _c("h5", {
                  staticClass: "lc-project-title",
                  domProps: { innerHTML: _vm._s(_vm.project.name) },
                }),
              ]
            ),
          ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }